import Vue from 'vue';
import VueResource from 'vue-resource';
import BootstrapVue from 'bootstrap-vue';
import VueI18n from 'vue-i18n';
import VueLayers from 'vuelayers';
import 'vuelayers/lib/style.css'; // needs css-loader
//import VueWebsocket from "vue-websocket";
import VueNativeSock from 'vue-native-websocket';


/* eslint-disable */

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
/* eslint-enable */

import VModal from 'vue-js-modal'
//import Simplert from 'vue2-simplert';
import App from './App.vue';
import store from './store';
import router from './router';

//Vue.use(Simplert);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueI18n);
Vue.use(VueLayers);
Vue.use(VModal);
//Vue.use(VueWebsocket, "ws://5jotas.4m1g0.com:1880/ws/5jotas");
//Vue.use(VueNativeSock, "wss://5jotas.4m1g0.com:1880/ws/5jotas");
Vue.use(VueNativeSock, "wss://nodered.armriot.com/ws/5jotas");
Vue.use(VueResource);

const messages = {
  en: {
    commons: {
      active: 'Active',
      name: 'Name',
      options: 'Options',
      tagWan: 'TagWAN',
    },
    navbar: {
      historical: 'Historical',
      language: 'Lang',
      logOut: 'Log Out',
      realTime: 'Map',
      user: 'User',
    },
    components: {
      map: {
        options: {
          titleShow: "Show",
          titleJotas: "Jotas",
          titleSelectedJota: "Selected Jota",
          free: "Free",
          loaded: "Loaded",
          freeJotas: "Free Platforms",
          loadedJotas: "Loaded Platforms",
          lincopys: "Lincopys",
          titleAdd: "Add",
        },
        autoCenter: 'Auto-center',
        displayedElements: 'Displayed Elements',
        filters: 'Filters',
        filtersAndOptions: 'Filters and Options',
        fixTime: 'Time',
        id: 'ID',
        listOfElements: 'List Of Elements',
        marker: {
          name: 'Name',
          value: 'Value',
        },
        speedUnits: 'Km/h',
        trackableTypes: {
          block: 'Block',
          vehicle: 'Vehicle',
          none: 'Not Assigned',
        },
      },
    },
  },
  es: {
    commons: {
      active: 'Activo',
      name: 'Nombre',
      options: 'Opciones',
      tagWan: 'TagWAN',
    },
    navbar: {
      historical: 'Histórico',
      language: 'Idioma',
      logOut: 'Cerrar sesión',
      realTime: 'Mapa',
      user: 'Usuario',
    },
    components: {
      map: {
        options: {
          titleShow: "Mostrar",
          titleJotas: "Jotas",
          titleSelectedJota: "Jota seleccionada",
          free: "Vacía",
          loaded: "Ocupada",
          freeJotas: "Vacías",
          loadedJotas: "Ocupadas",
          lincopys: "Lincopys",
          titleAdd: "Añadir registro"
        },
        autoCenter: 'Centrado automático',
        displayedElements: 'Elementos Mostrados',
        filters: 'Filtros',
        filtersAndOptions: 'Filtros y Opciones',
        fixTime: 'Hora',
        id: 'ID',
        listOfElements: 'Lista de Elementos',
        marker: {
          name: 'Nombre',
          value: 'Valor',
        },
        speedUnits: 'Km/h',
        trackableTypes: {
          block: 'Bloque',
          vehicle: 'Vehículo',
          none: 'Sin Asignar',
        },
      },
    },
  },
};

const i18n = new VueI18n({
  locale: 'es', // set locale
  messages, // set locale messages
});

new Vue({
  i18n,
  store,
  router,
  render: h => h(App),
}).$mount('#app');
